import { formatToIso } from "@repo/utils";
import useSWR from "swr";

import * as fetcher from "../fetcher";
import {
  type InstallationQuotationSearchProps,
  type InstallationQuotationsSearchResponse,
} from "./types";

const stringifyInstallationQuotationQuery = (
  props?: InstallationQuotationSearchProps
): string => {
  if (!props) {
    return "";
  }
  const searchParams = new URLSearchParams();

  if (props.unitId?.length) {
    searchParams.set("buFilter", props.unitId.join(","));
  }

  if (props.email?.length) {
    searchParams.set("coworkerFilter", props.email.join(","));
  }

  if (props.status?.length) {
    searchParams.set("status", props.status.join(","));
  }

  if (props.installQuoteValueFilter?.length === 2) {
    const [min, max] = props.installQuoteValueFilter;
    const valueFilter = `${Math.floor(min)}-${Math.ceil(max)}`;
    searchParams.set("installQuoteValueFilter", valueFilter);
  }

  if (
    Array.isArray(props.docusignDateSentFilter) &&
    props.docusignDateSentFilter.length === 2
  ) {
    const formatted = props.docusignDateSentFilter.map((date) =>
      formatToIso(new Date(date))
    );
    searchParams.set("docusignDateSentFilter", formatted.join("-"));
  }

  if (
    Array.isArray(props.installationFromDateFilter) &&
    props.installationFromDateFilter.length === 2
  ) {
    const formatted = props.installationFromDateFilter.map((date) =>
      formatToIso(new Date(date))
    );
    searchParams.set("installationFromDateFilter", formatted.join("-"));
  }
  if (props.depositPaid) {
    searchParams.set("depositPaid", String(props.depositPaid));
  }

  if (Array.isArray(props.teamId)) {
    searchParams.set("teamsFilter", props.teamId.join(","));
  } else if (props.teamId) {
    searchParams.set("teamsFilter", props.teamId);
  }

  searchParams.set("pageIndex", String(props.pageIndex ?? 0));
  searchParams.set("pageSize", String(props.pageSize ?? 5));

  return searchParams.toString();
};

export function useInstallationQuotationSearch(searchSettings?: any) {
  const queryString = searchSettings
    ? stringifyInstallationQuotationQuery(searchSettings)
    : "";

  return useSWR<InstallationQuotationsSearchResponse>(
    searchSettings
      ? `/opportunities/installation-quotation?${queryString}`
      : null,
    (url) => fetcher.core.get(url),
    {
      shouldRetryOnError: false,
      revalidateOnFocus: false,
    }
  );
}
